import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppConfigService } from './core/appConfig.service';

const ACCES_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const ISADMIN = 'isAdmin'
const CLIENT_ID = "client_id";
const ID_TOKEN = 'id_token';
const URL_CONFIG = 'urlConfig';

@Injectable({
  providedIn: 'root'
})

export class TokenService {

  private hostname_fe = '';
  private url_get_roles = '';
  private url_param_config: any;
  private token_url = '';

  constructor(private http: HttpClient,
    private configService: AppConfigService) {
  }

  /**
   * Función encargada de obtener los parámetros necesarios para realizar el login con KeyCloack
   * @returns 
   */
  getParamConfigLong(): Observable<any> {
    this.url_param_config = this.configService.apiUrl + '/r/p/config';
    return this.http.get<any>(this.url_param_config);
  }

  /**
   * Servicio encargada de realizar llamada al endpoint de la UOC para obtener el token
   * @param code 
   * @returns 
   */

  getToken(code: string): Observable<any> {
    this.token_url = localStorage.getItem('url_token') || '';
    localStorage.removeItem('url_token');
    let body = new URLSearchParams();
    body.set('grant_type', environment.grant_type);
    body.set('code', code);
    body.set('redirect_uri', this.configService.apiUrlFront);
    body.set('client_id', localStorage.getItem(CLIENT_ID) || '');
    localStorage.removeItem(CLIENT_ID);

    const headers_objects = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<any>(this.token_url, body.toString(), { headers: headers_objects });
  }

  setToken(access_token: string, refresh_token: string): void {
    localStorage.removeItem(ACCES_TOKEN);
    localStorage.setItem(ACCES_TOKEN, access_token);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.setItem(REFRESH_TOKEN, refresh_token);
  }

  getAccesToken(): string | null {
    return localStorage.getItem(ACCES_TOKEN);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN);
  }

  clearToken() {
    localStorage.removeItem(ACCES_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(ISADMIN);
    localStorage.removeItem(ID_TOKEN);
    localStorage.removeItem(URL_CONFIG);

    this.hostname_fe = this.configService.apiUrlFront;

    // Eliminar las cookies correctamente
    document.cookie = 'access_token=; Max-Age=0; path=/; domain=' + this.hostname_fe + '; secure; HttpOnly';
    document.cookie = 'refresh_token=; Max-Age=0; path=/; domain=' + this.hostname_fe + '; secure; HttpOnly';

    // También puedes eliminar cookies para otras rutas si es necesario
    document.cookie = 'access_token=; Max-Age=0; path=/; secure; HttpOnly';
    document.cookie = 'refresh_token=; Max-Age=0; path=/; secure; HttpOnly';
  }

  /**
   * Función encargada de validar si existe el token dentro del localStorage y verifica si no ha expirado
   * @returns 
   */
  isAuthenticate(): boolean {
    return (localStorage.getItem(ACCES_TOKEN) != null && !this.tokenExpired())
      ? true : false;
  }

  obtainNameUser(): string {
    return this.decryptToken().displayName;
  }

  obtainEmployeeNumber(): number {
    return this.decryptToken().employeeNumber;
  }

  obtainClientId(): string {
    return this.decryptToken().azp;
  }

  /**
   * Función que decodifica el token y devuelve los calsims en formato JSON
   * @returns 
   */
  private decryptToken(): any {
    const token = this.getAccesToken();
    if (!token) {
      return "";
    }
    // El token se contiene en tres partes, la segunda parte es donde viene la información de los claims
    const payload = token!.split(".")[1];

    // Decodificamos el Payload
    const payloadDecoded = atob(payload);
    const bytes = Uint8Array.from(payloadDecoded, c => c.charCodeAt(0));
    const decodedText = new TextDecoder("utf-8").decode(bytes);
    return JSON.parse(decodedText);
  }

  /**
   * Función para validar la expiración del token, comprueba que la fecha actual sea mayor a la fecha ubicada dentro del token.
   * @returns
   */
  tokenExpired(): boolean {
    // Convertirmos milsegundo en segundos y comparamos
    return new Date().getTime() / 1000 > this.decryptToken().exp ? true : false;
  }

  refreshTokenExpired(): boolean {
    const token = this.getRefreshToken();
    const payload = token!.split(".")[1];
    const payloadDecoded = atob(payload);
    return new Date().getTime() / 1000 > JSON.parse(payloadDecoded).exp ? true : false;
  }

  /**
     * Función encargada de llamar al BE para borrar las cookies y no se quede almacenado el JSSESIONID para poder loguearse nuevamente con otro usuario
     */
  clearTokenWithCookie(): void {
    if (!localStorage.getItem('urlConfig')) {
      window.location.href = window.location.origin + '/front/login'
    }
    const url_param_logout = localStorage.getItem('urlConfig')!.replace('token', 'logout');
    const idToken = localStorage.getItem("id_token")!;
    const clientId = this.obtainClientId();
    const redirect = window.location.origin + '/front/redirect-logout';

    const logoutUrl = `${url_param_logout}` +
      `?id_token_hint=${idToken}` +
      `&client_id=${clientId}` +
      `&post_logout_redirect_uri=${redirect}`;

    this.clearToken();

    window.location.href = logoutUrl;
  }

  obtainRoleUser(idTariffAgent: number): Observable<any> {
    this.url_get_roles = this.configService.apiUrl + '/r/p/obtain-user/';
    return this.http.get<any>(this.url_get_roles + idTariffAgent);
  }

  generateRefreshToken(): Observable<any> {
    let body = new URLSearchParams();
    let url = localStorage.getItem('urlConfig') || ''
    body.set('client_id', this.obtainClientId());
    body.set('grant_type', 'refresh_token');
    body.set('refresh_token', this.getRefreshToken() || '');

    const headers_objects = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<any>(url, body.toString(), { headers: headers_objects });

  }


}
